import langData from "../data/lang.json"

export const isTouchDevice = () => {
  return "ontouchstart" in window || (window.DocumentTouch && document instanceof DocumentTouch)
}

export const getNodeIndex = (el) => {
  var children = el.parentNode.childNodes
  var num = 0
  for (var i = 0; i < children.length; i++) {
    if (children[i] == el) return num
    if (children[i].nodeType == 1) num++
  }
  return -1
}

export const trigger = (eventId, data, scope) => {
  var event

  if (eventId != "pageScroll" && location.hostname == "localhost") {
    //debug
    console.log(eventId + " triggered" + (data ? ", event data: " + JSON.stringify(data) : ""))
  }

  if (!scope) scope = document
  scope.dispatchEvent(new CustomEvent(eventId, { detail: data }))
}

export const validateEmail = (email) => {
  const reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+.([A-Za-z]{2,4})$/
  return reg.test(email)
}

export const getLocale = () => {
  return document.querySelector("body").dataset.locale
}

export const lang = (id) => {
  return langData[getLocale()][id]
}

export const escapeHTML = (unsafe) => {
  return unsafe
    ? unsafe.replace(/[\u00A0-\u9999<>&]/g, (i) => {
        return `&#${i.charCodeAt(0)};`
      })
    : ""
}

export const offset = (el) => {
  const rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop

  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

export const isElementInViewport = (el, complete = true) => {
  if (el) {
    const bounds = el.getBoundingClientRect()

    if (!complete) {
      // check for just the top coordinate
      return bounds.top >= 0 && bounds.top <= window.innerHeight
    }

    return bounds.top >= 0 && bounds.bottom <= window.innerHeight
  }
  return false
}
